export default __webpack_public_path__ + "static/media/myevent-menu.5b294d79.svg";